//https://github.com/mattdesl/eases
export default {
  'quint-in-out': (t: any) => ((t *= 2) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2)),
  'quint-in': (t: any) => t * t * t * t * t,
  'quint-out': (t: any) => --t * t * t * t * t + 1
}
